import { defineStore } from 'pinia'

// 编辑单个陪玩项目配置
export const useAdminPlayerProjectConfStore = defineStore(
  'AdminPlayerProjectConf',
  () => {
    const editPlayerInfo = ref<{
      skuIds: string[]
      skuNames: string[]
      playerId: string
      playerName: string
    }>({
      playerId: '',
      playerName: '',
      // 修改多个项目，为空则修改全部sku
      skuIds: [],
      skuNames: [],
    })

    return {
      editPlayerInfo,
    }
  },
)
